module.exports = __webpack_public_path__ + "media/jackpot_winner_2.d1cc6553.mp3";